import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';


import 'rxjs/add/operator/map';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NgForm, NgModel, Validators } from '@angular/forms';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
    @ViewChild('identityInput', {static: false}) identityInput!: ElementRef;
    @ViewChild('passwordInput', {static: false}) passwordInput!: ElementRef;

    @Output('successfulLogin') successfulLogin: EventEmitter<any> = new EventEmitter();
    @Output('loginFailure') loginFailure: EventEmitter<any> = new EventEmitter();
    @Output('forgotPassword') forgotPassword: EventEmitter<any> = new EventEmitter();

    loginError = false;
    showErrors = false;
    isLoading: boolean;

    loginForm: UntypedFormGroup

    constructor(private formBuilder: UntypedFormBuilder, private authService: AuthenticationService) {

        this.loginForm = formBuilder.group({
            'identity': ['', Validators.required],
            'password': ['', Validators.required]
        });
    }

    ngOnInit() {

    }

    onLogin(credentials: any) {

        if (this.loginForm.invalid) {
            this.showErrors = true;
            return;
        }

        this.blurFormInputs();
        this.isLoading = true;
        this.authService.login(credentials).subscribe(
            (data: any) => {
                const identity = {identity: credentials.identity}
                const sentData = Object.assign(
                    {},
                    identity,
                    data);
                this.isLoading = false;
                this.successfulLogin.emit(sentData);
            },
            (error: any) => {
                this.isLoading = false;
                this.loginFailure.emit(error);
                this.loginError = true;
            }
        );
    }

    private blurFormInputs() {
        if (this.identityInput) {
            this.identityInput.nativeElement.blur();
        }
        if (this.passwordInput) {
            this.passwordInput.nativeElement.blur();
        }
    }


    control(name: string) {
        return this.loginForm.controls[name] as UntypedFormControl;
    }

}
